var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useContext } from 'react';
import { ThemeContext } from 'styled-components';
import { setColor } from '../icon.utilities';
export function SAIconChevronDown(_a) {
    var size = _a.size, colorVariant = _a.colorVariant, onClick = _a.onClick, icon = _a.icon, theme = _a.theme, additionalProps = __rest(_a, ["size", "colorVariant", "onClick", "icon", "theme"]);
    var iconTheme = useContext(ThemeContext);
    var color = setColor(iconTheme, colorVariant, 'secondary');
    var renderSize = size !== null && size !== void 0 ? size : '100px';
    return (React.createElement("svg", __assign({}, additionalProps, { width: renderSize, height: renderSize, viewBox: "0 0 100 100", version: "1.1", xmlns: "http://www.w3.org/2000/svg", xmlnsXlink: "http://www.w3.org/1999/xlink" }),
        React.createElement("g", { stroke: "none", strokeWidth: "1", fill: "none", fillRule: "evenodd", strokeLinecap: "round", strokeLinejoin: "round" },
            React.createElement("polyline", { strokeWidth: "8", stroke: color, transform: "translate(50.000000, 50.000000) rotate(180.000000) translate(-50.000000, -50.000000) ", points: "82 66 50 34 18 66" }))));
}
//# sourceMappingURL=icon.chevron-down.component.js.map